import AWS from './icons/aws.svg';
import AWSImage from './icons/aws.svg';
import Azure from './icons/azure.svg';
import CheckGradientIcon from './icons/check_gradient.svg';
import EmptyIcon from './icons/empty.svg';
import EmptyDarkIcon from './icons/empty_dark.svg';
import EnIcon from './icons/en.svg';
import EnDarkIcon from './icons/en_dark.svg';
import EnHoverIcon from './icons/en_hover.svg';
import GithubIcon from './icons/github.svg';
import GithubDarkIcon from './icons/github_dark.svg';
import GoogleCloudImage from './icons/google_cloud.svg';
import KrIcon from './icons/kr.svg';
import KrDarkIcon from './icons/kr_dark.svg';
import KrHoverIcon from './icons/kr_hover.svg';
import AdvIcon from './icons/label_adv.svg';
import AdvDarkIcon from './icons/label_adv_dark.svg';
import BasicIcon from './icons/label_basic.svg';
import BasicDarkIcon from './icons/label_basic_dark.svg';
import ProIcon from './icons/label_pro.svg';
import ProDarkIcon from './icons/label_pro_dark.svg';
import LinkedinIcon from './icons/linkedin.svg';
import LinkedinDarkIcon from './icons/linkedin_dark.svg';
import NavCatalogIcon from './icons/nav_catalog.svg';
import NavCatalogDarkIcon from './icons/nav_catalog_dark.svg';
import NavServiceIcon from './icons/nav_service.svg';
import NavServiceDarkIcon from './icons/nav_service_dark.svg';
import ServiceLoader from './icons/service_loader.svg';
import AiLogoImage from './images/ai_logo.png';
import AiLogoDarkImage from './images/ai_logo_dark.png';
import ArchitectureImage from './images/architecture.png';
import CardBgImage from './images/card_bg.png';
import ChatbotImage from './images/chatbot.png';
import ChatbotDarkImage from './images/chatbot_dark.png';
import CompleteImage from './images/complete.png';
import KeyInfoImage from './images/key_info.png';
import KeyInfoDarkImage from './images/key_info_dark.png';
import ListEmptyImage from './images/list_empty.png';
import LoaderImage from './images/loader.png';
import LoginCoverImage from './images/login_cover.png';
import LoginCoverDarkImage from './images/login_cover_dark.png';
import LoginGoogleIcon from './images/login_google.svg';
import LoginKakaoIcon from './images/login_kakao.svg';
import LogoImage from './images/logo_light.png';
import LogoLightImage from './images/logo_light.png';
import LogoMiniImage from './images/logo_mini.png';
import LogoMiniDarkImage from './images/logo_mini_dark.png';
import LogoDarkImage from './images/logo_white.png';
import NoticeIcon from './images/notice.svg';
import PlanBgImage from './images/plan_bg.png';
import StereoAIStudioIcon from './images/stereo_aistudio.png';
import StereoAppDarkIcon from './images/stereo_app.png';
import StereoAppLightIcon from './images/stereo_app.png';
import StereoBackDarkIcon from './images/stereo_back.png';
import StereoBackLightIcon from './images/stereo_back.png';
import StereoCdkDarkIcon from './images/stereo_cdk.png';
import StereoCdkLightIcon from './images/stereo_cdk.png';
import StereoFrontDarkIcon from './images/stereo_front.png';
import StereoFrontLightIcon from './images/stereo_front.png';
import StereoSolutionDarkIcon from './images/stereo_solution.png';
import StereoSolutionLightIcon from './images/stereo_solution.png';
import ThumbsDownIcon from './images/thumbs_down.svg';
import WorkspaceImage from './images/workspace.png';
import WorkspaceAdvImage from './images/workspace_adv.png';
import WorkspaceBasicImage from './images/workspace_basic.png';
import WorkspaceProImage from './images/workspace_pro.png';
import BoxBlackLogo1 from './logo/box-black-logo1.png';
import BoxBlackLogo2 from './logo/box-black-logo2.png';
import BoxBlackSymbol from './logo/box-black-symbol.png';
import BoxPurpleLogo1 from './logo/box-purple-logo1.png';
import BoxPurpleLogo2 from './logo/box-purple-logo2.png';
import BoxPurpleSymbol from './logo/box-purple-symbol.png';
import BoxWhiteLogo1 from './logo/box-white-logo1.png';
import BoxWhiteLogo2 from './logo/box-white-logo2.png';
import BoxWhiteSymbol from './logo/box-white-symbol.png';
import CodesLogoImage from './logo/codes_logo.png';

export * from './icons/Image.svg';

export {
    AdvDarkIcon,
    AdvIcon,
    AiLogoDarkImage,
    AiLogoImage,
    AWS,
    AWSImage,
    Azure,
    BasicDarkIcon,
    BasicIcon,
    EmptyDarkIcon,
    EmptyIcon,
    EnDarkIcon,
    EnHoverIcon,
    EnIcon,
    GithubDarkIcon,
    GithubIcon,
    GoogleCloudImage,
    KrDarkIcon,
    KrHoverIcon,
    KrIcon,
    LinkedinDarkIcon,
    LinkedinIcon,
    ProDarkIcon,
    ProIcon,
    CheckGradientIcon,
    StereoAppDarkIcon,
    StereoAppLightIcon,
    StereoBackDarkIcon,
    StereoBackLightIcon,
    StereoCdkDarkIcon,
    StereoCdkLightIcon,
    StereoFrontDarkIcon,
    StereoFrontLightIcon,
    StereoSolutionDarkIcon,
    StereoSolutionLightIcon,
    NavServiceIcon,
    NavCatalogIcon,
    NavServiceDarkIcon,
    NavCatalogDarkIcon,
    KeyInfoDarkImage,
    KeyInfoImage,
    LogoDarkImage,
    LogoImage,
    LogoLightImage,
    LogoMiniImage,
    LogoMiniDarkImage,
    LoginCoverImage,
    LoginCoverDarkImage,
    WorkspaceImage,
    WorkspaceBasicImage,
    WorkspaceProImage,
    WorkspaceAdvImage,
    CodesLogoImage,
    CardBgImage,
    PlanBgImage,
    ServiceLoader,
    ListEmptyImage,
    CompleteImage,

    // Box assets
    ArchitectureImage,
    ChatbotImage,
    ChatbotDarkImage,
    LoaderImage,
    LoginGoogleIcon,
    LoginKakaoIcon,
    NoticeIcon,
    ThumbsDownIcon,
    // Box logos
    BoxBlackLogo1,
    BoxBlackLogo2,
    BoxBlackSymbol,
    BoxPurpleLogo1,
    BoxPurpleLogo2,
    BoxPurpleSymbol,
    BoxWhiteLogo1,
    BoxWhiteLogo2,
    BoxWhiteSymbol,
    StereoAIStudioIcon,
};

// Box assets objects for compatibility
export const Images = {
    boxLogo: LoaderImage,
    boxBlackLogo: LoaderImage,
    logo: LogoImage,
    googleLogo: LoginGoogleIcon,
    kakaoLogo: LoginKakaoIcon,
    loader: LoaderImage,
    kr: KrIcon,
    krDark: KrDarkIcon,
    en: EnIcon,
    enDark: EnDarkIcon,
    chatBot: ChatbotImage,
    chatBotDark: ChatbotDarkImage,
    notice: NoticeIcon,
    thumbsDown: ThumbsDownIcon,
} as const;

export const Logo = {
    black1: BoxBlackLogo1,
    black2: BoxBlackLogo2,
    blackSymbol: BoxBlackSymbol,
    purple1: BoxPurpleLogo1,
    purple2: BoxPurpleLogo2,
    purpleSymbol: BoxPurpleSymbol,
    white1: BoxWhiteLogo1,
    white2: BoxWhiteLogo2,
    whiteSymbol: BoxWhiteSymbol,
} as const;
